module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAQpJREFUKBVjYICCrP2veGBsZLrh/3+mtDP/uWBiTCBG3MlPwu///T8ate9lH0wCRIMU39j3eu6nT693JR15zQsSYwSZDFL8n4FBDyTAxMjQv8xJvAimmIHhfwJInIGR8Sgfn6gjI4gNMvnff4ZCEBsEQJr+/WcUhCsGizLWrnAWawFrAPHRNYHVwAmIYhAXrgHEwa4JoRikBuxpEAPkZogzQDwEYGL8L4TgQW3A8CCyCiAbFhAgYSbsihlrQYpg+kABAgtylmdnGTiAPlFlAIYrBCDcDFTEAAu9/wyMmsAIZAV7GhQp33793w7UtAMUdDCtIBpkMkixiKxowGRVxp9wOZBuOAeNgSwHAO+0gJyzN0qaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/components/History/assets/clear.png
// module id = 358
// module chunks = 0